<template>
  <div class="row">
    <!--  题库列表  -->
    <div class="flex xs12">
      <va-card title="题库列表">
        <div class="row align--center mb-1">
          <div class="flex xs12">
            <va-button-group>
              <va-button flat color="gray" disabled>岗位：</va-button>
              <va-button
                flat
                :color="positionId === null ? 'info' : 'gray'"
                @click="handlePositionChange(null)"
              >
                全部岗位
              </va-button>
              <va-button
                v-for="option in positionOptions"
                :key="option.CODE"
                flat
                :color="positionId === option.CODE ? 'info' : 'gray'"
                @click="handlePositionChange(option.CODE)"
              >
                {{ option.TEXT }}
              </va-button>
            </va-button-group>

            <va-button-group>
              <va-button flat color="gray" disabled>类别：</va-button>
              <va-button
                flat
                :color="category === null ? 'info' : 'gray'"
                @click="handleCategoryChange(null)"
              >
                全部类别
              </va-button>
              <va-button
                v-for="option in categoryOptions"
                :key="option.CODE"
                flat
                :color="category === option.CODE ? 'info' : 'gray'"
                @click="handleCategoryChange(option.CODE)"
              >
                {{ option.TEXT }}
              </va-button>
            </va-button-group>

            <va-button-group>
              <va-button disabled flat color="gray">难度：</va-button>

              <!-- 全部难度按钮 -->
              <va-button
                flat
                :color="difficulty === null ? 'info' : 'gray'"
                @click="handleDifficultyChange(null)"
              >
                全部难度
              </va-button>

              <!-- 循环生成的具体难度按钮 -->
              <va-button
                v-for="status in statusOptions"
                :key="status.CODE"
                flat
                :color="difficulty === status.CODE ? 'info' : 'gray'"
                @click="handleDifficultyChange(status.CODE)"
              >
                {{ status.TEXT }}
              </va-button>
            </va-button-group>

          </div>
          <div class="flex md6 xs12 sm6">
            <va-input class="ma-0" :value="name" placeholder="搜索题目关键词" @input="search" removable>
              <va-icon name="fa fa-search" slot="prepend" />
            </va-input>
          </div>
          <div class="flex md3 xs12 sm6">
            <va-button class="mb-2" flat disabled color="danger">总计{{ totalCount }}条结果</va-button>
          </div>
          <div class="flex md3 xs12 sm6">
            <div class="d-flex justify--end">
              <!--              <va-button color="info" outline small :to='{name:`uploadQuestionExcel`}'>导入Execl</va-button>-->
              <va-button color="info" outline small @click="$router.push('saveQuestion')"
                :disabled="disabledCreate">新建题目</va-button>
            </div>
          </div>
        </div>

        <va-data-table :fields="fields" :data="questions" :loading="loading" :totalPages="totalPages"
          @page-selected="listQuestion" api-mode>

          <!-- 题目范围 -->
          <template slot="position" slot-scope="props">
            <span>{{ props.rowData.position }}</span>
          </template>

          <!-- 题目类别 -->
          <template slot="category" slot-scope="props">
            <span>{{ props.rowData.category }}</span>
          </template>

          <!-- 子类别 -->
          <template slot="subCategory" slot-scope="props">
            <span>{{ props.rowData.subCategory }}</span>
          </template>

          <!-- 难度信息 -->
          <template slot="difficulty" slot-scope="props">
            <va-badge :color="computeDifficultyColor(props.rowData.difficulty)"
              style="font-size: 110%; padding: 1px 1px; border-radius: 12px; font-weight: bold; text-transform: none;">
              {{ props.rowData.difficulty }}
            </va-badge>
          </template>

          <!-- 标题 -->
          <template slot="title" slot-scope="props">
            <span>{{ props.rowData.title }}</span>
          </template>

          <!-- 操作 -->
          <template slot="actions" slot-scope="props">
            <va-popover message="编辑" placement="top">
              <va-button flat small color="gray" icon="fa fa-pencil"
                @click="$router.push(`updateQuestion/${props.rowData.id}`)" :disabled="disabledEdit" />
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true; deleteId = props.rowData.id" :disabled="disabledDelete" />
            </va-popover>
          </template>
        </va-data-table>

        <va-modal v-model="deleteModal" title="删除题目" okText="提交" position="center" message="请再次确认是否要删除？"
          @ok="confirmDelete" />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import { dateFormat, formatTime } from '@/utils/common'
import questionApi from '@/api/question'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      referrals: [],
      questions: [],
      name: '',
      loading: true,
      pageNumber: 1,
      pageSize: 30,
      totalCount: 0,
      totalPages: 1,
      deleteModal: false,
      positionOptions: [],
      categoryOptions: [],
      statusOptions: [],
      deleteId: null,
      positionId: null, // 当前选中的 position
      category: null, // 当前选中的 category
      difficulty: null, // 当前选中的难度，默认展示所有难度（null）
      permissions: [],
      disabledDelete: false,
      disabledEdit: false,
      disabledCreate: false,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'position',
          title: '岗位',
          width: '60px',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'category',
          title: '题目类别',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'subCategory',
          title: '题目子类别',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:difficulty',
          title: '难度信息',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'title',
          title: '标题',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'updateTime',
          title: '更新时间',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listQuestion()
    this.refreshFilterOptions()
  },
  methods: {
    refreshFilterOptions () {
      const params = {
        positionId: this.positionId,
        category: this.category,
        difficulty: this.difficulty,
      }

      questionApi.getFilterOptions(params).then(data => {
        console.log('[FilterOptions] 原始返回数据:', data)

        // 自定义岗位排序顺序
        const desiredOrder = [
          'back-end-engineering',
          'front-end-engineering',
          'data-science',
          'machine-learning',
          'product-management',
          'behavioral',
        ]

        // 岗位：按照指定顺序排序
        this.positionOptions = (data.positions || [])
          .sort((a, b) => desiredOrder.indexOf(a.code) - desiredOrder.indexOf(b.code))
          .map(item => ({
            CODE: item.code,
            TEXT: item.text,
          }))

        // 将后端的 code/text 转换成 CODE/TEXT，供模板使用
        this.positionOptions = (data.positions || []).map(item => ({
          CODE: item.code,
          TEXT: item.text,
        }))
        this.categoryOptions = (data.categories || []).map(item => ({
          CODE: item.code,
          TEXT: item.text,
        }))
        this.statusOptions = (data.difficulties || []).map(item => ({
          CODE: item.code,
          TEXT: item.text,
        }))

        console.log('[FilterOptions] 转换后 positionOptions:', this.positionOptions)
      }).catch(error => {
        this.showToast(error.msg || '加载筛选项失败', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    handlePositionChange (positionId) {
      this.positionId = positionId // 更新选中的 position
      this.pageNumber = 1 // 重置分页为第一页
      this.refreshFilterOptions()
      this.listQuestion() // 重新加载数据
    },
    handleCategoryChange (category) {
      this.category = category // 更新选中的 category
      this.pageNumber = 1 // 重置分页为第一页
      this.refreshFilterOptions()
      this.listQuestion() // 重新加载数据
    },
    handleDifficultyChange (difficulty) {
      this.difficulty = difficulty // 更新选中的难度
      this.pageNumber = 1 // 重置分页为第一页
      this.refreshFilterOptions()
      this.listQuestion() // 重新加载数据
    },
    formatTime (time) {
      return dateFormat('YYYY-mm-dd HH:MM', new Date(time * 1000))
    },

    listQuestion (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        name: this.name,
        positionId: this.positionId, // 新增的筛选条件
        category: this.category, // 新增的筛选条件
        difficulty: this.difficulty, // 将难度作为筛选参数
      }
      questionApi.listQuestion(params).then(response => {
        this.questions = response.questions
        this.questions.forEach(x => {
          x.createTime = formatTime(x.createTime)
          x.updateTime = formatTime(x.updateTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => this.showToast(error.msg, {
        duration: 1000,
        icon: 'fa-warning',
        position: 'top-center',
        fullWidth: false,
      }))
    },
    confirmDelete () {
      if (this.deleteId === null) return
      questionApi.deleteQuestion(this.deleteId).then(response => {
        if (response.success === true) {
          this.showToast('岗位删除成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listQuestion(1)
        }
      }).catch(error => this.showToast(error.msg, {
        duration: 1000,
        icon: 'fa-warning',
        position: 'top-center',
        fullWidth: false,
      }))
    },
    computeDifficultyColor (difficulty) {
      switch (difficulty) {
        case 'Easy':
          return 'success' // 绿色
        case 'Medium':
          return 'primary' // 蓝色
        case 'Hard':
          return '#FFA500' // 黄色
        case 'Very Hard':
          return 'danger' // 红色
        default:
          return 'gray' // 默认灰色
      }
    },
    search: debounce(function (name) {
      this.name = name
      this.listQuestion()
    }, 400),
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

/deep/ .va-badge {
  background-color: inherit !important;
  color: white !important;
}

</style>
